<template>
  <ModalLayout icon="pen-slim" title="Edit CPM" @close="close">
    <ElForm ref="form" :model="form" :rules="rules" label-position="top" @submit.prevent.native>
      <p class="mb-3">
        Enter the new CPM value for '<strong>{{ meta.campaign?.name }}</strong
        >' campaign. Ensure it reflects any negotiated rates.
      </p>

      <ElFormItem prop="cpm" :error="errors.cpm">
        <span slot="label">CPM Value</span>
        <ElInput v-model.number="form.cpm" placeholder="Enter CPM" type="number" min="0" step="0.01" :maxlength="10" class="w-full" />
      </ElFormItem>
    </ElForm>
    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" type="primary" :loading="loading" :disabled="!isUpdated || loading" @click="submitForm">
        Save
      </el-button>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from './ModalLayout.vue'

export default {
  name: 'EditCpm',
  components: { ModalLayout },
  props: {
    meta: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      form: {
        cpm: null,
      },
      originalCpm: null,
      errors: {
        cpm: '',
      },
      rules: {
        cpm: [{ required: true, message: 'Please enter a valid CPM value.', trigger: 'blur' }],
      },
    }
  },
  computed: {
    isUpdated() {
      return this.form.cpm !== null && this.form.cpm !== this.originalCpm && this.form.cpm > 0
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.meta?.campaign?.cpm) {
        this.form.cpm = this.meta.campaign.cpm
        this.originalCpm = this.meta.campaign.cpm
      }
    },
    close() {
      this.$Modal.instance.isOpen = false
    },
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid && this.isUpdated) {
          this.loading = true
          try {
            await this.$store.dispatch('socialBoostCampaign/updateCampaignCpm', {
              campaign_id: this.meta.campaign.id,
              cpm: this.form.cpm,
            })
            this.$Modal.parent.reload('socialBoostCampaign/getCampaign', { id: this.meta.campaign.id })
            this.close()
          } catch (error) {
            console.error(error)
            this.$message.error('Failed to update CPM. Please try again.')
          } finally {
            this.loading = false
          }
        } else {
          console.log('Form invalid or CPM not updated.')
        }
      })
    },
  },
}
</script>
